import React from 'react';
import { useApiUsageStatus } from '../hooks/useApiUsageStatus';
import { FiRefreshCw, FiZap } from './icons/Icons';

const UsageQuotaCard = () => {
  const { usageStatus, loading, error, refetch } = useApiUsageStatus();

  if (loading) {
    return (
      <div className="card quota-card" style={{ padding: '20px', borderRadius: '12px', background: '#1e1e1e', color: '#fff' }}>
        <p>Chargement du quota...</p>
      </div>
    );
  }

  if (error || !usageStatus) {
    return (
      <div className="card quota-card" style={{ padding: '20px', borderRadius: '12px', background: '#1e1e1e', color: '#fff' }}>
        <p style={{ color: '#ff4d4d' }}>{error || 'Données indisponibles'}</p>
        <button onClick={refetch} style={{ background: '#333', color: '#fff', border: 'none', padding: '8px 12px', borderRadius: '6px', cursor: 'pointer' }}>
          <FiRefreshCw /> Réessayer
        </button>
      </div>
    );
  }

  const { daily_used, daily_remaining, usage_percent, status } = usageStatus;
  const limit = daily_used + daily_remaining;

  // Déterminer la couleur de la barre
  let barColor = '#4caf50'; // Vert
  if (usage_percent >= 90) {
    barColor = '#ff4d4d'; // Rouge
  } else if (usage_percent >= 70) {
    barColor = '#ff9800'; // Orange
  }

  const handleTestRequest = async () => {
    try {
      const response = await fetch('/api/usage/test-quota', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) {
        if (response.status === 429) {
          const data = await response.json();
          alert(`Limite atteinte ! Réessayez dans ${data.retry_after_seconds} s`);
          refetch();
          return;
        }
        throw new Error('Erreur HTTP ' + response.status);
      }
      
      refetch();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="card quota-card" style={{
      padding: '24px',
      borderRadius: '16px',
      background: 'linear-gradient(145deg, #1f1f2e, #181824)',
      boxShadow: '0 8px 16px rgba(0,0,0,0.4)',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0, fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FiZap style={{ color: barColor }} /> Jauge API
        </h3>
        <button onClick={refetch} style={{
          background: 'transparent', border: 'none', color: '#888', cursor: 'pointer', fontSize: '1.1rem'
        }} title="Actualiser">
          <FiRefreshCw />
        </button>
      </div>

      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '0.9rem', color: '#ccc' }}>
          <span>Utilisation</span>
          <span>{daily_used} / {limit} requêtes</span>
        </div>
        
        {/* Progress Bar Container */}
        <div style={{
          width: '100%',
          height: '10px',
          background: '#333',
          borderRadius: '5px',
          overflow: 'hidden'
        }}>
          {/* Progress Bar Fill */}
          <div style={{
            height: '100%',
            width: `${usage_percent}%`,
            background: barColor,
            transition: 'width 0.4s ease-out, background 0.4s ease-out'
          }} />
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}>
        <span style={{ fontSize: '0.85rem', color: status === 'cooldown' ? '#ff9800' : '#888' }}>
          {status === 'cooldown' ? `En attente (${usageStatus.retry_after_seconds}s)` : 'Prêt'}
        </span>
        
        <button onClick={handleTestRequest} style={{
          background: '#2c2c3e',
          color: '#fff',
          border: '1px solid #444',
          padding: '6px 12px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '0.85rem',
          transition: 'background 0.2s'
        }}
        onMouseOver={e => e.currentTarget.style.background = '#3a3a52'}
        onMouseOut={e => e.currentTarget.style.background = '#2c2c3e'}
        >
          Tester Quota
        </button>
      </div>
    </div>
  );
};

export default UsageQuotaCard;
